import { SERVICE, type ServiceType } from '@musinsa/packages-device-detection';
import { getCdnUrl } from '../common/utils';

const INTRO_CONTENT = {
  [SERVICE.MUSINSA]: {
    hero: {
      description:
        '큐레이터란 내가 큐레이션한 상품으로 수익을 창출할 수 있는\n무신사의 공식 인플루언서 마케팅 서비스입니다.',
      image: getCdnUrl('images/musinsa/intro/intro-service-overview-01.png'),
    },
    activityImages: {
      CONTENT01: getCdnUrl('images/musinsa/intro/intro-service-overview-02.png'),
      CONTENT02: getCdnUrl('images/musinsa/intro/intro-service-overview-03.png'),
    },
    benefits: [
      {
        title: '판매 수수료 최대 10% 지원',
        subText: '무신사가 수수료를 대신 내 드립니다.',
      },
      {
        title: '매월 무신사 스토어 20% 할인 쿠폰 5매 지급',
        subText: '전월 정산 대상자에게만 지급됩니다.',
      },
      {
        title: '무신사 스토어 및 기획전 정보 사전 공유',
        subText: '무진장 블프 등의 정보를 알려드립니다.',
      },
      {
        title: '무신사 및 입점 브랜드와 협업 기회 제공',
        subText: '숏폼 촬영, 인터뷰 등의 협업이 가능합니다.',
      },
    ],
  },
  [SERVICE['29CM']]: {
    hero: {
      description:
        '큐레이터란 내가 큐레이션한 상품으로 수익을 창출할 수 있는\n29CM의 공식 인플루언서 마케팅 서비스입니다.',
      image: getCdnUrl('images/29cm/intro/intro-service-overview-01-v2.png'),
    },
    activityImages: {
      CONTENT01: getCdnUrl('images/29cm/intro/intro-service-overview-02-v2.png'),
      CONTENT02: getCdnUrl('images/29cm/intro/intro-service-overview-03-v2.png'),
    },
    benefits: [
      {
        title: '판매 수수료 최대 10% 지원',
        subText: '29CM가 수수료를 대신 내 드립니다.',
      },
      {
        title: '매월 29CM 스토어 20% 할인 쿠폰 5매 지급',
        subText: '전월 정산 대상자에게만 지급됩니다.',
      },
      {
        title: '29CM 캠페인 및 기획전 정보 사전 공유',
        subText: '이구위크 등의 정보를 알려드립니다.',
      },
      {
        title: '29CM 및 입점 브랜드와 협업 기회 제공',
        subText: '숏폼 촬영, 인터뷰 등의 협업이 가능합니다.',
      },
    ],
  },
};

export const getIntroContent = (service: ServiceType) =>
  INTRO_CONTENT[service as keyof typeof INTRO_CONTENT] ?? INTRO_CONTENT[SERVICE['29CM']];
